import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type ResourcesResourceTypeListController from 'garaje/pods/resources/index/controller';
import type RoombaGraphqlService from 'garaje/services/roomba-graphql';
import type StateService from 'garaje/services/state';

export default class ResourcesResourceTypeListRoute extends Route {
  @service declare roombaGraphql: RoombaGraphqlService;
  @service declare state: StateService;
  @service declare store: Store;

  setupController(controller: ResourcesResourceTypeListController, model: Promise<void>, transition: Transition): void {
    super.setupController(controller, model, transition);
    void controller.loadResourceTypes.perform();
  }
}
